import { memo, useState } from "react";
import { useTranslate } from "../../../context/TranslationContext";
import Button from "../../button";
import YoutubeVideoModel from "../../modal/YoutubeVideoModel";

const CalculatorCard = (props) => {
  const { data, content } = props;
  const { t } = useTranslate("staticData");

  const [showYoutubeModal, setShowYoutubeModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const handleWatchVideo = (e) => {
    e.stopPropagation();
    const matchedSection = content?.data?.sections?.find(
      (section) => section.title.toLowerCase() === data.link.toLowerCase(),
    );
    if (matchedSection) {
      setVideoUrl(matchedSection.content);
      setShowYoutubeModal(true);
    }
  };

  return (
    <div className="press-card">
      <img src={data?.image} alt="" className="img-fluid press-card-img" />
      <div className="press-card-inner mt-3">
        <div className="d-flex flex-column w-100">
          <div className="flex-grow-1">
            <h6 className="text-uppercase">{data?.title}</h6>
          </div>
          <div className="flex-grow-1">
            <p
              className="m-0 p-sm"
              style={{
                minHeight: "3.5em",
                lineHeight: "1.5em",
              }}
            >
              {data?.description}
            </p>
          </div>
          <div className="flex-grow-1" onClick={handleWatchVideo}>
            <p
              className="m-0 p-md purple-text"
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
              {t("watchVideo")}
            </p>
          </div>
          <div className="w-100 text-center">
            <Button
              text={t("calcNow")}
              className="w-100 mt-2"
              to={data?.route}
            />
          </div>
        </div>
      </div>
      <YoutubeVideoModel
        show={showYoutubeModal}
        close={() => setShowYoutubeModal(false)}
        videoUrl={videoUrl}
        title={data?.title}
      />
    </div>
  );
};

export default memo(CalculatorCard);
